import React from "react";

import Multimedia, { ImageProps } from "@stadium/ui/src/components/multimedia/multimedia";

export const getCountryFlagUrl = (country = {}, type) => {
  const extension = type === "small" ? "PNG" : "svg";
  return `https://cdn.bystadium.com/flags/${type}/${country.iso}.${extension}`;
};

interface CountryProps {
  name: string;
  iso: string;
}

interface CountryFlagProps extends Omit<ImageProps, "type"> {
  country: CountryProps;
  type?: string;
  flagWidth?: number;
  flagHeight?: number;
  className?: string;
}

const CountryFlag: React.FC<CountryFlagProps> = ({
  country,
  type = "small",
  flagWidth = 24,
  flagHeight = 24,
  className = "country-flag",
  loading = "lazy",
  ...rest
}) =>
  country?.iso ? (
    <Multimedia
      type="image"
      isNextImage={false}
      displayLoader
      src={getCountryFlagUrl(country, type)}
      alt={`${country?.name ?? country?.iso} Flag`}
      width={flagWidth}
      height={flagHeight}
      className={className}
      loading={loading}
      legacyLazyload={false}
      {...rest}
    />
  ) : (
    <></>
  );

export default CountryFlag;
